module.exports = __webpack_public_path__ + "img/true.80f0ef7c.svg";